import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { IRecording } from '../../appointments/recording/RecordingState';
import { ICaremapNoteResponse } from '../model/NotesClient';
import { ListUlIcon } from '../../theme/Icons';
import { AIActionItems } from '../generic-notes/AIActionItems';
import { INote } from '../generic-notes/INote';

export const ActionItems: FC<{ note: ICaremapNoteResponse | INote; }> = ({ note }) => {
    const recording = note.otherAttributes?.recording as IRecording;
    return Boolean(recording?.summary?.actionItems?.length) && (
        <ViewNoteSection title="Action Items" Icon={ListUlIcon} showAIIcon>
            <AIActionItems recording={recording} />
        </ViewNoteSection>
    );
};
